// extracted by mini-css-extract-plugin
export default {"background":"EditarFicha_background__TUBEh","modal":"EditarFicha_modal__hPVTZ","hr":"EditarFicha_hr__q9Gx2","neuro":"EditarFicha_neuro__Nfe81","table":"EditarFicha_table__ZUTZW"};